/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React, { useContext, useState } from 'react';
import {
    object, string, shape, arrayOf, number, func, bool, node,
} from 'prop-types';
import ReactHTMLParser from 'react-html-parser';
import useStyles from 'isomorphic-style-loader/useStyles';
import { useSelector } from 'react-redux';
import { useFlags } from 'launchdarkly-react-client-sdk';
import ConnectedGraphqlProductSkus from '../../../GraphqlPDPSkus/GraphqlProductSkus';
import BYOAddItems from './BYOAddItems';
import style from './BYOProduct.module.css';
import BYOSelectedAddItemDetail from './BYOSelectedAddItemDetail';
import ProgressSteps from './ProgressSteps';
import NextButton from './NextButton';
import BYODecorativeSlider from './BYODecorativeSlider';
import AddonDialog from '../../../GraphqlAddon/AddonDialog';
import { getSelectedInlineAddons } from '../../../../../../../../state/ducks/App/App-Selectors';
import { CrossMerch } from '../../../../../CrossMerchContainer/CrossMerchContainer';
import ProductReview from '../../../ProductReview';
import { getBaseCode } from '../../../../../../../helpers/tracking/product/dataLayerProductHelpers';
import ProgressBar from './ProgressBar';

const BYOProductContentRight = ({
    addonContainer,
    data,
    selectedSku,
    skuData,
    content,
    handleSkuChange,
    location,
    brand,
    cyoData,
    handleMiniCartModalClick,
    nonCountableKey,
    selectedItemId,
    brandId,
    product,
    hasWine,
    handleMobileAgeVerification,
    deliverySLA,
    selectedAddons,
    showErrorMessage,
    setSelectedComponents,
    selectedItems,
    url,
    getMaxSelectable,
    maxSelectableForSku,
    setMaxSelectableForSku,
    setShowProgressBar,
    activeStep,
    nextStep,
    steps,
    prevStep,
    removeItems,
    directSteps,
}) => {
    useStyles(style);
    let skuConfig = {};
    let productUrl = '';
    if (content?.entries?.[0]) {
        skuConfig = content.entries[0].sku_section;
        productUrl = content.entries[0].url;
    }
    const {
        name,
        shortDescription,
    } = data;

    const imageName = data.image?.name ?? '';
    const imagePath = selectedSku?.image?.path ?? '';

    const { featureFlags = {} } = useContext(CrossMerch);
    const { isByoStaticProgressBarEnabled } = useFlags();
    const selectedBand = selectedItems?.band || {};
    const selectedAddItem = selectedItems?.addItems || {};

    const visibleGroups = cyoData?.cyoGroup?.filter((g) => g.type !== 'cyoNonCountable');
    const cyoBand = visibleGroups?.findIndex((item) => item.type === 'cyoBands');
    const maxGroupNumber = visibleGroups?.filter((item) => item?.numberofUnitsRequiredForComponent === getMaxSelectable());
    const selectAddonsV3 = useSelector(getSelectedInlineAddons);
    const pdpInlineAddon = featureFlags['is-inline-addons-pdp-enabled'] && selectAddonsV3?.length;
    const decorationBandMandatory = featureFlags['is-byo-decoration-mandatory-enabled'] && cyoBand !== -1;
    const disableDecorationBand = decorationBandMandatory && (selectedItems?.band?.groupName === '' || selectedItems?.band === undefined);
    const cartIconLabel = featureFlags['cart-icon-label']?.label.toLowerCase() || 'cart';
    // for add to cart
    const bandName = selectedSku?.cyo?.cyoGroup?.[0]?.type === 'cyoBands' && selectedSku?.cyo?.cyoGroup?.[0]?.name;
    const [nonCountableItems, setNonCountableItems] = useState([]);
    const compileSelectedItems = () => {
        const productArray = [...nonCountableItems];
        // Include the selected band
        if (selectedBand.groupName) {
            productArray.push({
                brandCode: brandId,
                productCode: selectedBand.productCode,
                productId: selectedBand.itemID,
                quantity: 1,
                componentType: 'CYO',
            });
        }
        Object.values(selectedAddItem).forEach((groupSelection) => {
            Object.entries(groupSelection).forEach(([itemID, item]) => {
                if (item.quantity) {
                    productArray.push({
                        brandCode: brandId,
                        productCode: item.productCode,
                        productId: itemID,
                        quantity: item.quantity,
                        componentType: 'CYO',
                    });
                }
            });
        });
        return productArray;
    };

    const getAddons = () => {
        const addonsComponents = [];
        selectAddonsV3.forEach((addon) => {
            const addonItem = {
                brandCode: brandId,
                productCode: addon.partNumber,
                componentType: 'ADDON',
                productId: addon.legacyId,
                quantity: addon.qty,
            };
            addonsComponents.push(addonItem);
        });
        return addonsComponents;
    };
    const isGroupProductSelected = (component) => {
        if (selectedAddItem && selectedAddItem[component.name]) {
            return selectedAddItem[component.name].groupProductSelected === component.numberofUnitsRequiredForComponent;
        }
        return false;
    };

    const handleItemMatch = selectedSku?.cyo?.cyoGroup?.length ? selectedSku.cyo.cyoGroup.every(isGroupProductSelected) : false;

    return (
        <>
            <h1 className={style.prodName}>{ReactHTMLParser(name) || ''}</h1>
            {(featureFlags['is-pdp-reviews-enabled'] && featureFlags['is-power-review-enabled']
                && (
                    <div className={style.yotpoReview}>
                        <ProductReview
                            showUnderTitle
                            product={data}
                            selectedSku={selectedSku}
                            partNumber={getBaseCode(data.partNumber)}
                            name={data.name}
                            productUrl={url}
                            image={{
                                path: imagePath,
                                name: imageName,
                            }}
                        />
                    </div>
                ))}
            <span className={style.description}>{ReactHTMLParser(shortDescription) || ''}</span>
            <ProgressSteps steps={steps} prevStep={prevStep} activeStep={activeStep} />
            {steps.map((item, index) => {
                const stepIndex = index + 1;
                const headingTitle = decorationBandMandatory && activeStep === directSteps + 1 ? 'Add a Custom Touch' : item.title;
                const heading = `${stepIndex}. ${headingTitle}`;
                switch (item.key) {
                    case 'giftSize':
                        if (skuData?.length) {
                            return (
                                <>
                                    {activeStep === stepIndex && selectedSku && (
                                        <>
                                            <p className={style.heading}  id={`step_${stepIndex}`}>{heading}</p>
                                            <ConnectedGraphqlProductSkus
                                                skuData={skuData}
                                                skuConfig={skuConfig}
                                                handleSkuChange={handleSkuChange}
                                                selectedSku={selectedSku}
                                                product={data}
                                                productUrl={productUrl}
                                                location={location}
                                                brand={brand}
                                                isPdpYotpoEnabled
                                                isByoProduct
                                            />
                                        </>
                                    )}
                                    {activeStep > 1 && (
                                        <>
                                            <div className={style.selectedItemContainer}>
                                                <p className={style.heading}>1. Gift Size</p>
                                                <span className={style.editButton} role="presentation" onClick={() => prevStep(1)}>Edit</span>
                                            </div>
                                            <p className={style.selectedItem}>{ReactHTMLParser(selectedSku?.name?.toLowerCase())}</p>
                                        </>
                                    )}
                                </>
                            );
                        }
                        break;
                    case 'addItem':
                        if (cyoData?.cyoGroup) {
                            return (
                                <>
                                    {activeStep === stepIndex
                                        && (
                                            <>
                                                <p className={style.heading} id={`step_${stepIndex}`}>{heading}</p>
                                                <p className={style.content}>Select your items from the choices below.</p>
                                                <BYOAddItems
                                                    cyoData={selectedSku.cyo}
                                                    nonCountableKey={nonCountableKey}
                                                    selectedItemId={selectedItemId}
                                                    brandId={brandId}
                                                    product={product}
                                                    showErrorMessage={showErrorMessage}
                                                    setSelectedComponents={setSelectedComponents}
                                                    maxSelectableItem={getMaxSelectable}
                                                    selectedItems={selectedItems}
                                                    compileSelectedItems={compileSelectedItems}
                                                    setNonCountableItems={setNonCountableItems}
                                                    setMaxSelectableForSku={setMaxSelectableForSku}
                                                    maxSelectableForSku={maxSelectableForSku}
                                                    stepIndex={stepIndex}
                                                />
                                            </>
                                        )}

                                    {activeStep > directSteps && selectedAddItem?.totalProductSelected > 0 && (
                                        <BYOSelectedAddItemDetail
                                            selectedItems={selectedAddItem}
                                            prevStep={prevStep}
                                            directSteps={directSteps}
                                        />
                                    )}
                                </>
                            );
                        }
                        break;
                    case 'decoration':
                        return visibleGroups?.map((group) => (
                            group.type === 'cyoBands'
                            && (
                                <>
                                    {activeStep === stepIndex
                                        && (
                                            <>
                                                <p className={style.heading}  id={`step_${stepIndex}`}>{heading}</p>
                                                <span>Wrap up your gift with one of our exclusive designs.</span>
                                                <BYODecorativeSlider
                                                    groupData={group}
                                                    selectedBand={selectedItems}
                                                    decorationBandMandatory={decorationBandMandatory}
                                                />

                                            </>
                                        )}
                                    {activeStep > stepIndex
                                        && (
                                            <>
                                                <div className={style.selectedItemContainer}>
                                                    <p className={style.heading}>{decorationBandMandatory ? `${directSteps + 1}. Add a Custom Touch` : heading}</p>
                                                    <span className={style.editButton} role="presentation" onClick={() => prevStep(directSteps + 1)}>Edit</span>
                                                </div>
                                                <span className={style.selectedItem}>{selectedBand.bandName ? selectedBand.bandName : 'No Item Selected'}</span>
                                            </>
                                        )}
                                </>
                            )
                        ));
                    case 'review':
                        return (
                            activeStep === stepIndex
                            && (
                                <>
                                    <p className={style.heading}  id={`step_${stepIndex}`}>{heading}</p>
                                    <p className={style.content}>{content.entries[0]?.byo?.review_copy || `Confirm your selections and add to ${cartIconLabel}.`}</p>
                                    {featureFlags['is-cyo-addon-enabled'] && <AddonDialog addonContainer={addonContainer} isByoProduct />}

                                </>
                            )
                        );

                    default: return null;
                }
                return '';
            })}
            {isByoStaticProgressBarEnabled && (!featureFlags['is-byo-mutiprogress-bar-enabled'] || maxGroupNumber?.length > 0) && activeStep === directSteps && (
                <ProgressBar
                    totalProductSelected={selectedItems?.addItems?.totalProductSelected}
                    maxSelectableForSku={maxSelectableForSku}
                    removeItem={removeItems}
                />
            )}
            <NextButton
                selectedSku={selectedSku}
                nextStep={nextStep}
                prevStep={prevStep}
                activeStep={activeStep}
                totalProductsSelected={selectedAddItem?.totalProductSelected}
                stepsLength={steps.length}
                selectedBand={selectedBand?.bandName}
                maxSelectable={getMaxSelectable}
                location={location}
                addons={pdpInlineAddon ? getAddons() : selectedAddons}
                deliveryMethod={deliverySLA}
                handleMobileAgeVerification={handleMobileAgeVerification}
                hasWine={hasWine}
                isBandItemSelected={bandName ? !!selectedBand.groupName : true}
                product={product}
                /*
                              FORMAT:
                              {
                                  brandCode: brandId,
                                  productCode: id,
                                  productId: legacyId,
                                  quantity: number,
                                  componentType: 'CYO'
                              }
                          */
                cyoSelectedComponents={compileSelectedItems}
                brandId={brandId}
                selectedItemId={selectedItemId}
                // for add to cart
                handleMiniCartModalClick={handleMiniCartModalClick}
                disableAddToCart
                handleItemMatch={handleItemMatch}
                maxGroupNumber={maxGroupNumber}
                disableDecorationBand={disableDecorationBand}
                setShowProgressBar={setShowProgressBar}
                directSteps={directSteps}
                skuData={skuData}
            />
        </>
    );
};

BYOProductContentRight.propTypes = {
    addonContainer: node,
    data: object.isRequired,
    selectedSku: shape({
        id: string.isRequired,
        name: string.isRequired,
        prices: arrayOf(
            shape({
                type: string.isRequired,
                value: number.isRequired,
                __typename: string.isRequired,
            }),
        ).isRequired,
        __typename: string.isRequired,
    }),
    skuData: arrayOf(
        shape({
            id: string.isRequired,
            name: string.isRequired,
            prices: arrayOf(
                shape({
                    type: string.isRequired,
                    value: number.isRequired,
                    __typename: string.isRequired,
                }),
            ).isRequired,
            __typename: string.isRequired,
        }),
    ).isRequired,
    brand: shape({
        domain: string.isRequired,
    }).isRequired,
    content: shape({
        entries: arrayOf(shape({
            sku_section: object.isRequired,
            url: string.isRequired,
        })),
    }).isRequired,
    handleSkuChange: func.isRequired,
    location: object,
    url: string,
    selectedItemId: string,
    brandId: string.isRequired,
    handleMiniCartModalClick: func.isRequired,
    cyoData: shape({
        maxQuantity: number.isRequired,
        cyoGroup: arrayOf(
            shape({
                name: string.isRequired,
                components: arrayOf(
                    shape({
                        id: string.isRequired,
                        name: string.isRequired,
                        image: shape({
                            name: string.isRequired,
                            path: string.isRequired,
                        }),
                    }),
                ).isRequired,
            }),
        ).isRequired,
    }),
    product: object.isRequired,
    hasWine: bool,
    handleMobileAgeVerification: func,
    nonCountableKey: string.isRequired,
    deliverySLA: string.isRequired,
    selectedAddons: arrayOf(shape({
        id: string,
        ageVerifyFlag: bool,
        partNumber: string,
        name: string,
    })),
    showErrorMessage: func.isRequired,
    setSelectedComponents: func,
    selectedItems: object,
    steps: object.isRequired,
    prevStep: func.isRequired,
    nextStep: func.isRequired,
    activeStep: number.isRequired,
    setShowProgressBar: func.isRequired,
    getMaxSelectable: func,
    setMaxSelectableForSku: func,
    maxSelectableForSku: number,
    removeItems: func,
    directSteps: number,
};

BYOProductContentRight.defaultProps = {
    addonContainer: () => null,
    url: '',
    selectedItemId: null,
    hasWine: false,
    handleMobileAgeVerification: () => { },
    selectedAddons: [],
    setSelectedComponents: () => { },
    location: {},
    selectedItems: {},
    selectedSku: {},
    cyoData: {},
    getMaxSelectable: () => {},
    setMaxSelectableForSku: () => {},
    maxSelectableForSku: 0,
    removeItems: () => {},
    directSteps: 2,
};

export default BYOProductContentRight;
